<mat-dialog-content aria-labelledby="dialog-title" class="d-flex flex-col">
    @if (currentMedia) {
        <div class="flex-row flex-space-between">
            <div>
                <mat-card-header class="p-0">
                    @if (currentMedia?.title) {
                        <mat-card-title>
                            <h3 class="m-0" id="dialog-title">
                                @if (!copyMedia) {
                                    Move
                                }
                                @if (copyMedia) {
                                    Duplicate
                                }
                                {{ currentMedia?.title }}
                            </h3>
                        </mat-card-title>
                    }
                </mat-card-header>
            </div>
            <div class="float-end">
                <button class="mat-dialog-close " mat-dialog-close mat-icon-button matTooltip="Close Modal">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div class="d-flex flex-row mobile-col justify-content-center">
            <div class="leftSection flex-col flex-space-between ">
                <div class="flex-col gap10">
                    @if (copyMedia) {
                        <app-timeline-search (timelineSelect)="selectedTimeline($event)"
                                             [title]="'Memory Box'"/>
                    }
                    @if (timeline) {
                        <app-memories-search (memorySelect)="selectMemory($event)" [showSearchBtn]="false"
                                             [timeline]="timeline"
                                             [title]="'Select Album'"/>
                    }
                    <div class="mt-10">
                        @if (!copyMedia) {
                            <button (click)="moveMedia()" [disabled]="!album" color="primary"
                                    mat-raised-button>Move
                            </button>
                        }
                        @if (copyMedia) {
                            <button (click)="copyMediaOver()" [disabled]="!album" color="primary"
                                    mat-raised-button>Duplicate
                            </button>
                        }
                    </div>
                </div>
                <div class="flex-col">
                    @if (currentMedia?.description) {
                        <small>Description: {{ currentMedia?.description }}</small>
                    }
                    @if (currentMedia.user) {
                        <small>Author: {{ currentMedia.user| nameDisplay }}</small>
                    }
                    <small>Date: {{ currentMedia.created_date | date }}</small>
                </div>
            </div>
            <div class="flex-col w-100 px-10 pb-10">
                <app-media-display [file]="currentMedia"></app-media-display>
            </div>
        </div>
    }
    @if (!currentMedia) {
        <div class="centerLoading">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
    }
</mat-dialog-content>

